import { createAction } from '@ngrx/store';

export const entityStepperNext = createAction('[ENTITYSTEPPER] Next step');
export const entityStepperReset = createAction('[ENTITYSTEPPER] Reset step');
